import { render, staticRenderFns } from "./profiles_list.vue?vue&type=template&id=6d7b1b0a&scoped=true"
import script from "./profiles_list.vue?vue&type=script&lang=js"
export * from "./profiles_list.vue?vue&type=script&lang=js"
import style0 from "./profiles_list.vue?vue&type=style&index=0&id=6d7b1b0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7b1b0a",
  null
  
)

export default component.exports